import { InputAdornment, TextField } from '@material-ui/core'
import React, { useState } from 'react'
import { useEffect } from 'react';

const TextFieldEdit = ({ handleChange, initialValue, isNumeric = false, isMoney }) => {
    const [value, setValue] = useState(initialValue);
    const [idTimer, setIdTimer] = useState(0)

    useEffect(() => {
        setValue(initialValue)
    }, [initialValue])

    const handle = event => {
        const value = event.target.value
        setValue(value)

        clearTimeout(idTimer)
        const newIdTimer = setTimeout(() => handleChange(value), 500)
        setIdTimer(newIdTimer)
    }
    return (
        <div>
            <TextField
                type={isNumeric ? "number" : "text" }
                value={value}
                onChange={(handle)}
                fullWidth={true}
                InputProps={{
                    endAdornment: <InputAdornment position="start">{isMoney ? "€" : ""}</InputAdornment>,
                }}
            />
        </div>
    )
}

export default TextFieldEdit